import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
//import _ from 'lodash/lodash.min.js'

import authModule from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        httpRunning: false,
        errorList: []
    },
    mutations: {
        startHttpRunning (state) { state.httpRunning = true },
        stopHttpRunning (state) { state.httpRunning = false },
        addError (state, error) {
            state.errorList.unshift(error)
        },
        clearErrors (state) { state.errorList = [] }
    },
    modules: {
        auth: authModule
    },
    plugins: [createPersistedState({
        reducer: function (state, paths) {
            return { auth: state.auth }
        }
    })]
})



// WEBPACK FOOTER //
// ./src/store/index.js